export const FIELD_MAPPING = {
    amName: 'accountManagerName',
    rodeoAdName: 'rodeoAdvertiserName',
    brand: 'brandName',
    exactBillingValue: 'roValue',
    sfOpportunityId: 'sfOpportunityId',
    commentsByPoc: 'commentsByPOC',
    gtmStatus: 'gtmStatus',
    org: 'orgName',
} as const;

export const NON_CONTEXTUAL_PACKAGE_NAME = 'gateway'